import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/publicationCompatiblePagination/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/publicationCompatiblePagination/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/publicationCompatiblePagination/FETCH_FAILURE'

const CREATE_REQUEST = 'realbase/publicationCompatiblePagination/CREATE_REQUEST'
const CREATE_SUCCESS = 'realbase/publicationCompatiblePagination/CREATE_SUCCESS'
const CREATE_FAILURE = 'realbase/publicationCompatiblePagination/CREATE_FAILURE'

const DELETE_REQUEST = 'realbase/publicationCompatiblePagination/DELETE_REQUEST'
const DELETE_SUCCESS = 'realbase/publicationCompatiblePagination/DELETE_SUCCESS'
const DELETE_FAILURE = 'realbase/publicationCompatiblePagination/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loadedForKeys: [],
  loading: false,
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadPublicationCompatiblePaginations(options){
  const { entityKey } = options

  return (dispatch, getState) => {
    const state = getState()
    const loadedForKeys = [...state.publicationCompatiblePaginations.loadedForKeys]
    if (entityKey && !loadedForKeys.includes(entityKey)){
      loadedForKeys.push(entityKey)
    }

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/publication_compatible_paginations.json', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PUBLICATION_COMPATIBLE_PAGINATION_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function createPublicationCompatiblePagination(publicationCompatiblePagination, options){
  const config = {
    method: 'POST',
    data: JSON.stringify({
      publication_compatible_pagination: publicationCompatiblePagination,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/publication_compatible_paginations.json', options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PUBLICATION_COMPATIBLE_PAGINATION)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deletePublicationCompatiblePagination(publicationCompatiblePagination){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/publication_compatible_paginations/${publicationCompatiblePagination.id}.json`, {}, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PUBLICATION_COMPATIBLE_PAGINATION)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
